import React from 'react';
import { PageLead } from './partials/PageLead';
import { PageLeadDescription } from './partials/PageLeadDescription';
import { PageLeadHeadline } from './partials/PageLeadHeadline';
import { PageLeadMetaInfo } from './partials/PageLeadMetaInfo';
import { PageLeadSkipLinks } from './partials/PageLeadSkipLinks';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PageLeadPageTypeDefinition } from './partials/PageLeadPageTypeDefinition';
import { BlockType } from '../../../types/api/ElementType';

export type RolePageLeadProps = {
  title: string;
  leadText?: string;
  elementType: BlockType.usertopagerolepagelead | BlockType.usertouserrolepagelead;
};

export function PageLeadRole({ title, leadText, elementType }: RolePageLeadProps) {
  const { t } = useSonTranslation('RolePageLead');
  return (
    <>
      <PageLead>
        <PageLeadDescription aria-hidden="true">{t(`${elementType}.name`)}</PageLeadDescription>
        <PageLeadHeadline>
          {title}
          <PageLeadMetaInfo />
        </PageLeadHeadline>
        {
          elementType &&
          <PageLeadPageTypeDefinition type={t('roleType')}>{t(`${elementType}.name`)}</PageLeadPageTypeDefinition>
        }
        {leadText && <p className="page-lead__subheadline font-regular-16-24">{leadText}</p>}{' '}
      </PageLead>
      <PageLeadSkipLinks />
    </>
  );
}
